import {
  GetOrderDetailData,
  GetTransportShippedDetailData,
} from "services/interface";
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Space,
  Tag,
  Typography,
} from "antd";

import styled from "@emotion/styled";
import { useGetTransportType, useMasterTransport } from "hooks/useMasterData";
import { useEffect, useState } from "react";
import { CrownOutlined } from "@ant-design/icons";

interface ModalOderDetailProps {
  item: GetTransportShippedDetailData | undefined;
  open: boolean;
  onClose: () => void;
  childrenBank: React.ReactNode[];
  refetchData: () => void;
  statusPage?: string;
  refectShipped?: () => void;
  showEditModal?: (order_id: string, ref_id: string) => void;
  refetchPrepare?: () => void;
  isProductProblem?: boolean;
  oderDetail: GetOrderDetailData | undefined;
}

const ModalOderDetail = ({
  item,
  onClose,
  open,
  childrenBank,
  refetchData,
  statusPage,
  refectShipped,
  showEditModal,
  refetchPrepare,
  isProductProblem,
  oderDetail,
}: ModalOderDetailProps) => {
  const { data: transportTypeData } = useGetTransportType();

  const [transportText, setTransportText] = useState<string>("");

  const [formPostal] = Form.useForm();

  const { data, isLoading, refetch } = useMasterTransport({
    search: "",
  });

  useEffect(() => {
    if (transportTypeData) {
      const transport = transportTypeData.find(
        (i) => i.key === item?.transport_type
      );

      // if (transport) {
      //   setTransportText(transport.name);
      // }
      setTransportText(
        transport?.name ? transport.name : item?.transport_type || ""
      );
    }
  }, [transportTypeData, item]);

  useEffect(() => {
    if (oderDetail?.history_postal.brand_id) {
      formPostal.setFieldsValue({
        selectOrganize: oderDetail?.history_postal.brand_name,
        postalCode: oderDetail?.history_postal.postal_code,
        description: oderDetail?.history_postal.transport_detail,
        remark: oderDetail?.history_postal.postal_remark,
      });
    }
  }, [formPostal, oderDetail]);

  const renderTransportLabel = (transport: string) => {
    switch (transport) {
      case "post_office":
        return (
          <>
            {" "}
            <div>
              <div style={{ marginBottom: 10 }}>
                <Typography.Text style={{ fontSize: 14, fontWeight: 400 }}>
                  ข้อมูลจัดส่งจริง
                </Typography.Text>
              </div>
              <Form form={formPostal}>
                <Form.Item label="ประเภทขนส่ง" name="selectOrganize">
                  <Input
                    size="small"
                    placeholder="ประเภทขนส่ง"
                    readOnly={true}
                  />
                </Form.Item>
                <Form.Item label="เลข Tracking" name="postalCode">
                  <Input
                    size="small"
                    placeholder="เลข Tracking"
                    readOnly={true}
                  />
                </Form.Item>
                {/* <Form.Item label="รายละเอียด" name="description">
                  <Input.TextArea placeholder="รายละเอียด" readOnly={true} />
                </Form.Item> */}
                <Form.Item label="หมายเหตุจัดส่ง" name="remark">
                  <Input.TextArea
                    placeholder="หมายเหตุจัดส่ง"
                    readOnly={true}
                  />
                </Form.Item>
              </Form>
            </div>
          </>
        );
      case "taxi":
        return (
          <>
            {" "}
            <div>
              <div style={{ marginBottom: 10 }}>
                <Typography.Text style={{ fontSize: 14, fontWeight: 400 }}>
                  ข้อมูลจัดส่งจริง
                </Typography.Text>
              </div>
              <Form form={formPostal}>
                <Form.Item label="ประเภทขนส่ง" name="selectOrganize">
                  <Input
                    size="small"
                    placeholder="ประเภทขนส่ง"
                    readOnly={true}
                  />
                </Form.Item>
                <Form.Item label="เลข Tracking" name="postalCode">
                  <Input
                    size="small"
                    placeholder="เลข Tracking"
                    readOnly={true}
                  />
                </Form.Item>
                {/* <Form.Item label="รายละเอียด" name="description">
                    <Input.TextArea placeholder="รายละเอียด" readOnly={true} />
                  </Form.Item> */}
                <Form.Item label="หมายเหตุจัดส่ง" name="remark">
                  <Input.TextArea
                    placeholder="หมายเหตุจัดส่ง"
                    readOnly={true}
                  />
                </Form.Item>
              </Form>
            </div>
          </>
        );
      case "pick_up_yourself":
        return (
          <>
            {" "}
            <div style={{ marginBottom: 10 }}>
              <Typography.Text strong style={{}}>
                ข้อมูลจัดส่งจริง
              </Typography.Text>
              {oderDetail?.history_transport.box_list.map((item, index) => {
                return (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <div style={{ flex: 3 }}>
                      <Typography.Text style={{ fontWeight: "400" }}>
                        {`จำนวนกล่อง ${item.name}`}
                      </Typography.Text>
                    </div>
                    <div style={{ flex: 4 }}>
                      <Typography.Text>{item.qty}</Typography.Text>
                    </div>
                  </div>
                );
              })}
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ flex: 3 }}>
                  <Typography.Text style={{ fontWeight: "400" }}>
                    หมายเหตุจัดส่ง
                  </Typography.Text>
                </div>
                <div style={{ flex: 4 }}>
                  <Typography.Text>
                    {oderDetail?.history_transport_location.location_remark}
                  </Typography.Text>
                </div>
              </div>
            </div>
          </>
        );
      default:
        return (
          <>
            {" "}
            <div style={{ marginBottom: 10 }}>
              <Typography.Text strong style={{}}>
                ข้อมูลจัดส่งจริง
              </Typography.Text>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ flex: 3 }}>
                  <Typography.Text style={{ fontWeight: "400" }}>
                    จังหวัด
                  </Typography.Text>
                </div>
                <div style={{ flex: 4 }}>
                  <Typography.Text>{oderDetail?.province_name}</Typography.Text>
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ flex: 3 }}>
                  <Typography.Text style={{ fontWeight: "400" }}>
                    อำเภอ
                  </Typography.Text>
                </div>
                <div style={{ flex: 4 }}>
                  <Typography.Text>{oderDetail?.district_name}</Typography.Text>
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ flex: 3 }}>
                  <Typography.Text style={{ fontWeight: "400" }}>
                    จุดจอด
                  </Typography.Text>
                </div>
                <div style={{ flex: 4 }}>
                  <Typography.Text>
                    {oderDetail?.history_transport.history_parking_name}
                  </Typography.Text>
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ flex: 3 }}>
                  <Typography.Text style={{ fontWeight: "400" }}>
                    ขนส่ง
                  </Typography.Text>
                </div>
                <div style={{ flex: 4 }}>
                  <Typography.Text>
                    {oderDetail?.history_transport.transport_name}
                  </Typography.Text>
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ flex: 3 }}>
                  <Typography.Text style={{ fontWeight: "400" }}>
                    เวลาถึง
                  </Typography.Text>
                </div>
                <div style={{ flex: 4 }}>
                  <Typography.Text>
                    {oderDetail?.history_transport.end_time}
                  </Typography.Text>
                </div>
              </div>
              {oderDetail?.history_transport.box_list.map((item, index) => {
                return (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <div style={{ flex: 3 }}>
                      <Typography.Text style={{ fontWeight: "400" }}>
                        {`จำนวนกล่อง ${item.name}`}
                      </Typography.Text>
                    </div>
                    <div style={{ flex: 4 }}>
                      <Typography.Text>{item.qty}</Typography.Text>
                    </div>
                  </div>
                );
              })}
              <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ flex: 3 }}>
                  <Typography.Text style={{ fontWeight: "400" }}>
                    หมายเหตุจัดส่ง
                  </Typography.Text>
                </div>
                <div style={{ flex: 4 }}>
                  <Typography.Text>
                    {oderDetail?.history_transport.remark_box}
                  </Typography.Text>
                </div>
              </div>
            </div>
          </>
        );
    }
  };

  return (
    <>
      {item && (
        <div>
          <Modal
            open={open}
            // maskClosable={false}
            onCancel={onClose}
            width={854}
            footer={null}
            style={{ top: 20 }}
          >
            <div style={{ borderBottom: "1px solid #f0f0f0" }}>
              <Row style={{ marginBottom: 10 }}>
                <Col style={{}} span={12}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <Typography.Text>{`${item?.order_code}`}</Typography.Text>
                    <div
                      style={{
                        marginRight: 10,
                        borderRight: "1px solid #f0f0f0",
                      }}
                    ></div>
                    {/* <ModalPrintPurchaseOrder item={item} /> */}
                  </div>
                </Col>
                <Col
                  span={12}
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Button
                    type="default"
                    onClick={() => {
                      // new window
                      window.open(`/print-deliverynote/${item?.order_id}`);
                    }}
                    style={{ marginRight: "20px" }}
                  >
                    พิมพ์ใบส่งของ
                  </Button>
                </Col>
              </Row>
            </div>

            <Row>
              <Col span={12} xs={24} md={24} lg={24} xl={12} style={{}}>
                {/* <Table columns={columns} dataSource={item.items} /> */}
                <HeaderTab>
                  <Typography.Text
                    style={{
                      fontWeight: "normal",
                      paddingBottom: 5,
                      paddingTop: 5,
                    }}
                  >
                    รายการสินค้า
                  </Typography.Text>
                </HeaderTab>
                <div style={{ borderRight: "1px solid #f0f0f0" }}>
                  <Space
                    direction="vertical"
                    size="middle"
                    style={{
                      display: "flex",
                      height: "60vh",
                      overflowY: "scroll",
                      paddingRight: 10,
                      paddingTop: 10,
                    }}
                  >
                    {oderDetail?.items.map((i, index) => (
                      <div key={i.sku_id}>
                        <Row>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              width: "100%",
                            }}
                          >
                            <div style={{ marginRight: 10 }}>
                              <Checkbox />
                            </div>
                            <div style={{ flex: 1.5 }}>
                              <img
                                src={i.image_url}
                                alt={i.product_name}
                                style={{
                                  width: 80,
                                  height: 80,
                                  marginRight: 10,
                                }}
                              />
                            </div>
                            <div style={{ flex: 3, marginLeft: 10 }}>
                              <Typography.Paragraph style={{ marginBottom: 0 }}>
                                {i.product_name}
                              </Typography.Paragraph>
                              <Typography.Paragraph
                                style={{ fontSize: "12px" }}
                              >
                                {i.sku_name}
                              </Typography.Paragraph>
                        
                            </div>
                            <div
                              style={{
                                flex: 1,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "end",
                              }}
                            >
                              <Typography.Paragraph style={{ marginBottom: 0 }}>
                                จำนวน {i.sku_cnt}
                              </Typography.Paragraph>
                              {/* <Typography.Paragraph style={{ marginBottom: 0 }}>
                                ราคา {numberFormat(i.sku_price* i.sku_cnt)} 
                              </Typography.Paragraph> */}
                            </div>
                          </div>
                          {i.contact_comment_item && (
                                <Typography.Paragraph
                                  style={{ fontSize: "12px", marginTop: 5, marginLeft: 25,  whiteSpace: 'pre-line' }}
                                >
                                    <span style={{ fontWeight: 500,   }} >โน๊ตผู้ประกอบการ:</span> &nbsp;
                                  {i.contact_comment_item}
                                </Typography.Paragraph>
                              )}
                        </Row>
                      </div>
                    ))}
                  </Space>
                </div>
              </Col>

              <Col span={12} xs={24} md={24} lg={24} xl={12}>
                <HeaderTab>
                  <Typography.Text
                    style={{
                      fontWeight: "normal",
                      paddingBottom: 5,
                      paddingTop: 5,
                    }}
                  >
                    การจัดส่ง
                  </Typography.Text>
                </HeaderTab>
                <div
                  style={{
                    // borderRight: "1px solid #f0f0f0",
                    // height: "71.5vh",
                    overflowY: "scroll",
                  }}
                >
                  <div style={{ padding: 30 }}>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <div style={{ flex: 2 }}>
                        <Typography.Text style={{ fontWeight: "400" }}>
                          ประเภทการจัดส่ง
                        </Typography.Text>
                      </div>
                      <div style={{ flex: 4 }}>
                        <Typography.Text>{transportText}</Typography.Text>
                      </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <div style={{ flex: 2 }}>
                        <Typography.Text style={{ fontWeight: "400" }}>
                          ชื่อผู้รับ
                        </Typography.Text>
                      </div>
                      <div style={{ flex: 4 }}>
                        <Typography.Text>
                          {oderDetail?.address_name}{" "}
                          {oderDetail?.ref_is_vip && (
                            <Tag color="red">
                              <CrownOutlined /> VIP
                            </Tag>
                          )}
                        </Typography.Text>
                      </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <div style={{ flex: 2 }}>
                        <Typography.Text style={{ fontWeight: "400" }}>
                          ประเภท
                        </Typography.Text>
                      </div>
                      <div style={{ flex: 4 }}>
                        <Typography.Text>
                          {oderDetail?.ref_source}
                        </Typography.Text>
                      </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <div style={{ flex: 2 }}>
                        <Typography.Text style={{ fontWeight: "400" }}>
                          เบอร์โทรศัพท์
                        </Typography.Text>
                      </div>
                      <div style={{ flex: 4 }}>
                        <Typography.Text>
                          {item.address_telephone}
                        </Typography.Text>
                      </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <div style={{ flex: 2 }}>
                        <Typography.Text style={{ fontWeight: "400" }}>
                          ที่อยู่
                        </Typography.Text>
                      </div>
                      <div style={{ flex: 4 }}>
                        <Typography.Text>{item.address_text}</Typography.Text>
                      </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <div style={{ flex: 2 }}>
                        <Typography.Text style={{ fontWeight: "400" }}>
                          จุดจอด
                        </Typography.Text>
                      </div>
                      <div style={{ flex: 4 }}>
                        <Typography.Text>
                          {oderDetail?.parking_name}
                        </Typography.Text>
                      </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <div style={{ flex: 2 }}>
                        <Typography.Text style={{ fontWeight: "400" }}>
                          หมายเหตจุดจอด
                        </Typography.Text>
                      </div>
                      <div style={{ flex: 4 }}>
                        <Typography.Text>
                          {oderDetail?.address_remark}
                        </Typography.Text>
                      </div>
                    </div>
                  </div>
                  <div style={{ borderTop: "1px solid #f0f0f0" }}></div>
                  <div style={{ padding: 10 }}>
                    {/* {item.transport_type === "post_office" ? <></> : <></>} */}
                    {renderTransportLabel(item.transport_type)}
                  </div>
                </div>
              </Col>
            </Row>
            <div style={{ borderTop: "1px solid #f0f0f0" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  flexDirection: "row",
                  alignItems: "end",
                  marginTop: 10,
                }}
              ></div>
            </div>
          </Modal>
        </div>
      )}
    </>
  );
};

export default ModalOderDetail;

const HeaderTab = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #f0f0f0;
`;
